


import { ConsigneeSearchController } from "./controllers/consigneeSearchController";

import "./services/consigneeService";
import "./services/regionService";

import './templates/consigneeSearch.scss';
import '../../../../../core/directives/readOnlyText/readOnlyTextDirective';
import  '../../../requestDetailEdit/models/requestConsignee';
import  '../../../requestDetailEdit/models/requestShipment';


export function consigneeSearchDirective(): ng.IDirective {
    return <ng.IDirective>{
        template: require("./templates/consigneeSearch.html"),
        controller: ConsigneeSearchController,
        controllerAs: "vm",
        bindToController: {
            requestDetailEdit: "=",
            isConsigneeSearchLoading: "=",
            isConsigneeSearchValid: "="
        },
        scope: true,
        link: function (scope, element, attrs, ctrl: ConsigneeSearchController) {
            scope.$watch('vm.isUsDestination', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    ctrl.onIsUsDestinationChange();
                }
            });
        }
    }
}

angular
    .module("deliveryCreate.app")
    .directive("consigneeSearch", consigneeSearchDirective);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/addRequest/directives/consigneeSearch/consigneeSearchDirective.ts
 **/